import { render, staticRenderFns } from "./configurationForm.vue?vue&type=template&id=139a5ec9&scoped=true&"
import script from "./configurationForm.vue?vue&type=script&lang=js&"
export * from "./configurationForm.vue?vue&type=script&lang=js&"
import style0 from "./configurationForm.vue?vue&type=style&index=0&id=139a5ec9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a5ec9",
  null
  
)

export default component.exports